<template>
    <section class="tabs__panel"
             role="tabpanel"
             :class="{'tabs__panel--active': isActive}"
             :id="computedId"
             :aria-hidden="!isActive"

    >
        <div class="tabs__transition">
            <slot />
        </div>
    </section>
</template>
<script>
export default {
    props: {
        id: {default: null},
        name: {required: true}
    },
    data() {
        return {isActive: false};
    },
    computed: {
        header() { return this.name; },
        computedId() {
            return this.id ? this.id : this.name.toLowerCase().replace(/ /g, '-');
        },
        hash() { return `${window.location.pathname}#${this.computedId}`; }
    }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/tab.vue